window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));

  // Global sections event listeners
  // Section select
  $(document).on('shopify:section:select', function(evt) {
    if (evt.detail.sectionId !== 'sidebar-menu') {
      theme.LeftDrawer.close();
    }
  });
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) return;

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});


/* ================ MODULES ================ */
window.a11y = window.a11y || {};

a11y.trapFocus = function($container, eventNamespace) {
  var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

  $container.attr('tabindex', '-1').focus();

  $(document).on(eventName, function(evt) {
    if ($container[0] !== evt.target && !$container.has(evt.target).length) {
      $container.focus();
    }
  });
};

a11y.removeTrapFocus = function($container, eventNamespace) {
  var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

  $container.removeAttr('tabindex');
  $(document).off(eventName);
};

window.Modals = (function() {
  var Modal = function(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('body, html')
    };
    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.$focusOnOpen
    ? $(this.config.$focusOnOpen)
    : this.$modal;
    this.init();
  };

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) return;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    a11y.trapFocus(this.$focusOnOpen, 'modal_focus');

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) return;

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.nodes.$parent.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    a11y.removeTrapFocus(this.$focusOnOpen, 'modal_focus');

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$parent.on(
      'keyup.modal',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$parent.off('.modal');
  };

  return Modal;
})();

/**
 *  Vendor
 *
 *  Small minified vendor scripts can be placed at the top of this file to
 *  reduce network requests.
 *
 */

/**
 *
 *  ShopifyCanvas JS
 *  - Base Canvas functions and utilities.
 *
 */

window.ShopifyCanvas = window.ShopifyCanvas || {};

/**
 *
 *  Initialize function for all ShopifyCanvas JS.
 *  - call any functions required on page load here.
 *
 */
ShopifyCanvas.init = function() {
  ShopifyCanvas.cacheSelectors();
  ShopifyCanvas.checkUrlHash();
  ShopifyCanvas.initEventListeners();
  ShopifyCanvas.resetPasswordSuccess();
  ShopifyCanvas.customerAddressForm();
};

/**
 *
 *  Cache any jQuery objects.
 *
 */
ShopifyCanvas.cacheSelectors = function() {
  ShopifyCanvas.cache = {
    $html: $('html'),
    $body: $('body')
  };
};

ShopifyCanvas.initEventListeners = function() {
  //Show reset password form
  $('#RecoverPassword').on('click', function(evt) {
    evt.preventDefault();
    ShopifyCanvas.toggleRecoverPasswordForm();
  });

  //Hide reset password form
  $('#HideRecoverPasswordLink').on('click', function(evt) {
    evt.preventDefault();
    ShopifyCanvas.toggleRecoverPasswordForm();
  });
};

/**
 *
 *  Show/Hide recover password form
 *
 */
ShopifyCanvas.toggleRecoverPasswordForm = function() {
  $('#RecoverPasswordForm').toggleClass('hide');
  $('#CustomerLoginForm').toggleClass('hide');
};

/**
 *
 *  Show reset password success message
 *
 */
ShopifyCanvas.resetPasswordSuccess = function() {
  var $formState = $('.reset-password-success');

  //check if reset password form was successfully submited.
  if (!$formState.length) return;

  // show success message
  $('#ResetSuccess').removeClass('hide');
};

/**
 *
 *  Show/hide customer address forms
 *
 */
ShopifyCanvas.customerAddressForm = function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) return;

  // Initialize observers on address selectors, defined in shopify_common.js
  new Shopify.CountryProvinceSelector(
    'AddressCountryNew',
    'AddressProvinceNew',
    {
      hideElement: 'AddressProvinceContainerNew'
    }
  );

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (
      confirm(confirmMessage || 'Are you sure you wish to delete this address?')
    ) {
      Shopify.postLink('/account/addresses/' + formId, {
        parameters: { _method: 'delete' }
      });
    }
  });
};

/**
 *
 *  Check URL for reset password hash
 *
 */
ShopifyCanvas.checkUrlHash = function() {
  var hash = ShopifyCanvas.getHash();

  // Allow deep linking to recover password form
  if (hash === '#recover') {
    ShopifyCanvas.toggleRecoverPasswordForm();
  }
};

/**
 *
 *  Get the hash from the URL
 *
 */
ShopifyCanvas.getHash = function() {
  return window.location.hash;
};

// Initialize ShopifyCanvas's JS on docready
$(ShopifyCanvas.init);

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus({
      $container: this.$drawer,
      $elementToFocus: this.$drawer.find('.drawer__close-button'),
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode !== 27) return;

        this.close();
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) return;

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  /**
  * Traps the focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  Drawer.prototype.trapFocus = function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  };

  return Drawer;
})();

theme.SidebarMenuSection = (function() {
  function SidebarMenuSection() {
    $('.drawer-nav__toggle').on('click', function() {
      $(this)
      .parent()
      .toggleClass('drawer-nav--expanded');

      if (
        $(this)
        .parent()
        .hasClass('drawer-nav--expanded')
      ) {
        $(this)
        .children('.drawer-nav__toggle-button')
        .attr('aria-expanded', true);
        $(this)
        .find('.icon-plus')
        .removeClass('icon-plus')
        .addClass('icon-minus');
      } else {
        $(this)
        .children('.drawer-nav__toggle-button')
        .attr('aria-expanded', false);
        $(this)
        .find('.icon-minus')
        .removeClass('icon-minus')
        .addClass('icon-plus');
      }
    });
  }

  return SidebarMenuSection;
})();

theme.SidebarMenuSection.prototype = _.assignIn(
  {},
  theme.SidebarMenuSection.prototype,
  {
    onSelect: function() {
      theme.RightDrawer.close();
      theme.SearchDrawer.close();
      theme.LeftDrawer.open();
    },

    onDeselect: function() {
      theme.LeftDrawer.close();
    }
  }
);

theme.HeaderSection = (function() {
  function HeaderSection() {
    theme.drawersInit();
  }

  return HeaderSection;
})();

theme.HeaderSection.prototype = _.assignIn({}, theme.HeaderSection.prototype, {
  onSelect: function() {
    theme.LeftDrawer.close();
  }
});

theme.ActionBarSection = (function() {
  function ActionBarSection() {
    theme.ActionBar.init();
  }

  return ActionBarSection;
})();

theme.ActionBarSection.prototype = _.assignIn(
  {},
  theme.ActionBarSection.prototype,
  {
    onSelect: function() {
      theme.LeftDrawer.close();
    }
  }
);

theme.NewsletterSection = (function() {
  function NewsletterSection() {
    theme.styleTextLinks();
  }

  return NewsletterSection;
})();

theme.PasswordContentSection = (function() {
  function PasswordContentSection() {
    theme.styleTextLinks();
  }

  return PasswordContentSection;
})();


/**
 *
 *  Boundless Theme JS
 *
 *
 */
theme.init = function () {
  theme.cacheSelectors();
  //theme.stringOverrides();
  theme.drawersInit();
  //theme.initCart();
  //theme.afterCartLoad();
  //theme.rteImages();
  theme.styleTextLinks();
  //theme.searchSubmit();
  //theme.socialSharing();
  theme.passwordTemplate();
  theme.newsletterTemplate();
  //theme.responsiveVideos();
  //theme.checkIfIOS();
};

/**
 *
 *  Cache any jQuery objects.
 *
 */
theme.cacheSelectors = function () {
  theme.cache = {
    $window: $(window),
    $html: $('html'),
    $body: $('body'),
    $indexTemplate: $('.template-index'),
    //$cartSectionTemplate: $('.cart-template-section'),

    // Drawer elements
    $drawerRight: $('.drawer--right'),
    //$drawerProduct: $('.drawer--product'),
    //$cartContainer: $('#CartContainer'),

    // Product grid
    //$productGridItem: $('.product-item'),

    // Share buttons
    //$shareButtons: $('.social-sharing'),

    // Article images
    //$indentedRteImages: $('.rte--indented-images'),

    // Password Page
    $loginModal: $('#LoginModal'),
    $newsletterModal: $('#NewsletterModal'),

    // Announcement Bar
    //$announcementBar: $('.announcement-bar'),

    // Site Header
    $siteHeaderWrapper: $('.site-header-wrapper'),
    $siteHeader: $('.site-header-container'),
    //$siteHeaderCart: $('.site-header__cart'),
    //$searchInput: $('.search-bar__input'),
    //$searchSubmit: $('.search-bar__submit'),

    // Hero
    //$heroContentWrapper: $('.hero__content-wrapper'),
    //$hero: $('#Hero'),
    //$heroImages: $('.hero__image'),

    // Cart classes
    cartNoCookies: 'cart--no-cookies'

  }

  theme.variables = {
    isIndexTemplate: theme.cache.$indexTemplate.length,

    // Footer
    footerTop: 0,

    // track window width to solve iOS scroll triggering resize event
    windowWidth: theme.cache.$window.width()
  };
};

theme.drawersInit = function () {
  // Add required classes to HTML
  $('#PageContainer').addClass('drawer-page-content');
  $('.js-drawer-open-left').attr('aria-controls', 'NavDrawer').attr('aria-expanded', 'false');
  /*$('.js-drawer-open-right').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');
  $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');*/

  theme.LeftDrawer = new theme.Drawers('NavDrawer', 'left');
  /*theme.RightDrawer = new theme.Drawers('CartDrawer', 'right', {
    
  });
  theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {'onDrawerOpen': theme.searchFocus});*/
};

theme.styleTextLinks = function () {
  $('.rte').find('a:not(:has(img))').addClass('text-link');
}

theme.setFocus = function ($container, eventNamespace) {
  var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

  $container.attr('tabindex', '-1');

  $container.focus();

  $(document).on(eventName, function (evt) {
    if ($container[0] !== evt.target && !$container.has(evt.target).length) {
      $container.focus();

      //only set focus once
      $(document).off(eventName)
      $container.removeAttr('tabindex');
    }
  });
};

theme.passwordTemplate = function () {
  if (!theme.cache.$loginModal.length) return;

  // Initialize modal
  theme.PasswordModal = new window.Modals('LoginModal', 'login-modal', {
    $focusOnOpen: '#Password'
  });

  // Open modal if errors exist
  if (theme.cache.$loginModal.find('.errors').length) {
    theme.PasswordModal.open();
  }
};

theme.newsletterTemplate = function () {
  if (!theme.cache.$newsletterModal.length) return;

  // Initialize modal
  theme.NewsletterModal = new window.Modals('NewsletterModal', 'newsletter-modal', {
    $focusOnOpen: '#newsletterModal'
  });

  // Open modal if errors exist
  if (theme.cache.$newsletterModal.find('.errors').length) {
    theme.NewsletterModal.open();
  }
};

/* Age verification Popup
-------------------------------------------------------*/
var verification_popup = {
  init: function(){
    var popup = $.cookie('ageverification');
    var cookie_enabled = true;
    
    //music player
    var theWindow = $(window),
        theBody = $('body'),
        audioPlayer = $("#audioPlayer"),
        audioControl = $('#audioControl'),
        audioSpan = $('#audioControl span');
    
    var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);

    //CLICK
    audioControl.click(function() {
      if(audioControl.hasClass('playing')) verification_popup.pauseAudio();
      else verification_popup.playAudio();
    });
    //HOVER
    audioControl.hover(function(){
      if(audioControl.hasClass('paused')){
        audioSpan.each(function(i) {
          verification_popup.hoverBar($(this));
        });
      }
    },function(){
      if(audioControl.hasClass('paused')) verification_popup.pauseBar();
    });
    //LOOP
    if(audioPlayer.length > 0){
      audioPlayer[0].loop = true;
    }

    var someLink = document.querySelector('#audioControl');

    if (cookie_enabled && popup == 'open') {
      if ($('body').hasClass('hasaudio') && !isMobile) {
        //verification_popup.simulateClick(someLink);
        //window.location = "/products/mod-selection-blanc-de-blanc";
      }
    } else {
      verification_popup.open();
    }
    
    $('.age-gate-submit-yes').click(function() {
      /*if(!isMobile){*/
      	//verification_popup.simulateClick(someLink);
        //window.location = "/products/mod-selection-blanc-de-blanc";
      /*}*/
      if (cookie_enabled) {
        $.cookie('ageverification', 'open', {expires:1, path:'/'});
      }
    })
    
  },
  playAudio: function(){
    var audioPlayer = $("#audioPlayer");
    var audioSpan = $('#audioControl span');
    var audioControl = $('#audioControl');
    audioPlayer[0].play().catch(function() {
      // do something
    });
    audioPlayer.animate({volume: .35}, 1000);
    audioControl.removeClass('paused').addClass('playing');
    audioSpan.each(function(i) {
      verification_popup.playingBar($(this));
    });
  },
  //PAUSE
  pauseAudio: function(){
    var audioPlayer = $("#audioPlayer");
    var audioControl = $('#audioControl');
    audioPlayer.animate({volume: 0}, 1000, function() {
      audioPlayer[0].pause();
      audioControl.removeClass('playing').addClass('paused');
    });
    verification_popup.pauseBar();
  },
  //PLAYING FUNCTION
  playingBar: function(bar) {
    var height = Math.random() * 20 + 3;
    var timing = height * 16;

    bar.animate({
      height: height
    }, timing, function() {
      verification_popup.playingBar($(this));
    });
  },
  //PAUSE FUNCTION
  pauseBar: function() {
    var audioSpan = $('#audioControl span');
    audioSpan.stop(true,false).animate({height:'8px'},500);
  },
  //HOVER FUNCTION
  hoverBar: function(bar) {
    var height = Math.random() * 20 + 3;
    var timing = height * 10;

    bar.stop(true,true).animate({
      height: height
    }, timing);
  },
  //PAUSE IF PLAYING
  pauseIfPlaying: function(){
    var audioControl = $('#audioControl');
    if(audioControl.hasClass('playing')){ 
      verification_popup.pauseAudio(); 
      audioControl.addClass('holding'); 
    }
  },
  simulateClick: function(elem) {
    // Create our event (with options)
    var evt = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    // If cancelled, don't dispatch our event
    var canceled = !elem.dispatchEvent(evt);
  },
  open: function(){
    setTimeout( function() {
      $('[data-remodal-id=age-verification]').remodal().open();
    })
  }
}

// Stefan's Additions
var MODLocationsToBuy = [{"name":"12TH STREET LIQUOR","address":"1205 E BRIDGE STREET","city":"BRIGHTON","state":"CO","location":{"lat":39.986953,"lng":-104.806685}},{"name":"23RD AVENUE LIQUORS","address":"3210 23RD AVE","city":"EVANS","state":"CO","location":{"lat":40.3839828,"lng":-104.7153294}},{"name":"484 LIQUORS","address":"1354 SE HIGHWAY 484","city":"OCALA","state":"FL","location":{"lat":29.0251233,"lng":-82.1205045}},{"name":"7 STAR LIQUORS","address":"3305 N LEWIS AVE.","city":"WAUKEGAN","state":"IL","location":{"lat":42.41233039999999,"lng":-87.85479160000001}},{"name":"ABC LIQUORS 160","address":"1540 SE FEDERAL HWY","city":"STUART","state":"FL","location":{"lat":27.1846257,"lng":-80.2440846}},{"name":"ART'S LIQUOR","address":"18366 SOLEDAD CYN","city":"SANTA CLARITA","state":"CA","location":{"lat":34.4158236,"lng":-118.4541355}},{"name":"BEAR VALLEY RANCH MARKET","address":"32475 CLINTON KEITH RD","city":"WILDOMAR","state":"CA","location":{"lat":33.5881354,"lng":-117.2527725}},{"name":"BEVERLY HILLS LIQUOR & WI","address":"8316 WILSHIRE BL","city":"BEVERLY HILLS","state":"CA","location":{"lat":34.0641831,"lng":-118.3726595}},{"name":"BIG E WINE & LIQUOR","address":"690 MCLEAN AVE","city":"YONKERS","state":"NY","location":{"lat":40.908819,"lng":-73.87513799999999}},{"name":"BOARDWALK WINE & SPIRITS","address":"1195A HALSEY ST","city":"BROOKLYN","state":"NY","location":{"lat":40.6913209,"lng":-73.90986529999999}},{"name":"BOURBON WINES & SPIRITS","address":"5005 FOOTHILLS BLVD  STE 2","city":"ROSEVILLE","state":"CA","location":{"lat":38.7596301,"lng":-121.3080749}},{"name":"BRANDYWINE LIQUOR","address":"1655 BRANDYWINE AV","city":"CHULA VISTA","state":"CA","location":{"lat":32.6016496,"lng":-117.0286981}},{"name":"BRONX LIQUOR WAREHOUSE","address":"2101 GRAND CONCOURSE","city":"BRONX","state":"NY","location":{"lat":40.8542302,"lng":-73.90275299999999}},{"name":"CASK WINE & SPIRITS (THE)","address":"1304 CHESTNUT ST Suite D","city":"MURRAY","state":"KY","location":{"lat":36.6173752,"lng":-88.3168697}},{"name":"CG ANCILLARY BATTLE OF MA","address":"300 E CROSSROADS PKWY","city":"BOLINGBROOK","state":"IL","location":{"lat":41.67743309999999,"lng":-88.06045100000001}},{"name":"CG GRAND CRU TABLE 18 SAT","address":"300 E CROSSROADS PKWY","city":"BOLINGBROOK","state":"IL","location":{"lat":41.67743309999999,"lng":-88.06045100000001}},{"name":"CG GRAND CRU TABLE 18 SUN","address":"300 E CROSSROADS PKWY","city":"BOLINGBROOK","state":"IL","location":{"lat":41.67743309999999,"lng":-88.06045100000001}},{"name":"CG SAT CR HOLLYWOOD&WINE","address":"300 E CROSSROADS PKWY","city":"BOLINGBROOK","state":"IL","location":{"lat":41.67743309999999,"lng":-88.06045100000001}},{"name":"CHAMBERS PLACE LIQUOR","address":"4856 N CHAMBERS RD","city":"DENVER","state":"CO","location":{"lat":39.7856495,"lng":-104.8078229}},{"name":"CITY MARKET 21","address":"7611 FOOTHILL BL","city":"TUJUNGA","state":"CA","location":{"lat":34.2551974,"lng":-118.2982107}},{"name":"COLONIAL WINES & LIQUOR","address":"416 E SANDFORD BLVD","city":"MOUNT VERNON","state":"NY","location":{"lat":40.901134,"lng":-73.82054099999999}},{"name":"CROSS BRONX WAREHOUSE LIQ","address":"961 E 174 ST","city":"BRONX","state":"NY","location":{"lat":40.8370465,"lng":-73.88495089999999}},{"name":"CROWN LIQ AND WINE 7","address":"3500 N FEDERAL HWY","city":"BOCA RATON","state":"FL","location":{"lat":26.3818847,"lng":-80.0758991}},{"name":"DAVE'S LIQUOR & FOOD","address":"1347 OLIVER RD","city":"FAIRFIELD","state":"CA","location":{"lat":38.2568096,"lng":-122.0683039}},{"name":"DECO LIQUORS","address":"7271 NW 36TH ST","city":"MIAMI","state":"FL","location":{"lat":25.8099456,"lng":-80.3155809}},{"name":"DESERT WINE SHOP","address":"73360 HWY 111 ","city":"PALM DESERT","state":"CA","location":{"lat":33.7217289,"lng":-116.3849537}},{"name":"EL GATO TUERTO II","address":"1260 SW 8TH STREET","city":"MIAMI","state":"FL","location":{"lat":25.7656642,"lng":-80.2157702}},{"name":"EXPRESS LIQUOR","address":"3322 E HAMMER LN STE F","city":"STOCKTON","state":"CA","location":{"lat":38.0204892,"lng":-121.2731425}},{"name":"FEDERAL FULFILLMENT","address":"464-484 WEGNER ROAD","city":"LAKEMOOR","state":"IL","location":{"lat":42.3217223,"lng":-88.205879}},{"name":"FOREMOST SUNSET CORNERS (","address":"8701 SUNSET DRIVE","city":"MIAMI","state":"FL","location":{"lat":25.7024789,"lng":-80.3344082}},{"name":"FOREMOST SUNSET CORNERS (","address":"8701 SUNSET DRIVE","city":"MIAMI","state":"FL","location":{"lat":25.7024789,"lng":-80.3344082}},{"name":"GARNET WINES & LIQUORS","address":"929 LEXINGTON AVENUE","city":"NEW YORK","state":"NY","location":{"lat":40.7679629,"lng":-73.96360159999999}},{"name":"GLENDALE LIQUOR","address":"1309 E COLORADO ST","city":"GLENDALE","state":"CA","location":{"lat":34.1428498,"lng":-118.2372429}},{"name":"GOODY GOODY LIQUOR (06)","address":"7729 GARLAND ROAD","city":"DALLAS","state":"TX","location":{"lat":32.8125308,"lng":-96.7278664}},{"name":"GOODY GOODY LIQUOR (10)","address":"14851 INWOOD ROAD","city":"ADDISON","state":"TX","location":{"lat":32.9508909,"lng":-96.8311518}},{"name":"GOODY GOODY LIQUOR (12)","address":"1950 FM 407 W JUSTIN ROAD","city":"HIGHLAND VILLAGE","state":"TX","location":{"lat":33.0723056,"lng":-97.04793699999999}},{"name":"GOODY GOODY LIQUOR (15)","address":"3316 OAKLAWN AVENUE","city":"DALLAS","state":"TX","location":{"lat":32.8104345,"lng":-96.80700580000001}},{"name":"GOODY GOODY LIQUOR (16)","address":"103 FM 423","city":"LITTLE ELM","state":"TX","location":{"lat":33.169774,"lng":-96.8878996}},{"name":"GOODY GOODY LIQUOR (17)","address":"6393 CAMP BOWIE BOULEVARD","city":"FORT WORTH","state":"TX","location":{"lat":32.7247829,"lng":-97.4213178}},{"name":"GOODY GOODY LIQUOR (26)","address":"4701 COLLEYVILLE BOULEVARD","city":"COLLEYVILLE","state":"TX","location":{"lat":32.8781764,"lng":-97.15666929999999}},{"name":"GOODY GOODY LIQUOR (43)","address":"6401 WOODWAY DRIVE SUITE 149","city":"HOUSTON","state":"TX","location":{"lat":29.7545956,"lng":-95.49883849999999}},{"name":"GRAND VIEW MARKET","address":"13302 RANCHERO ST","city":"OAK HILLS","state":"CA","location":{"lat":34.3834293,"lng":-117.3720851}},{"name":"GREAT PASTIMES","address":"228 N MAIN","city":"MONTICELLO","state":"IA","location":{"lat":42.2396848,"lng":-91.18357929999999}},{"name":"GREEN'S DISCOUNT LIQUOR","address":"17539 IMPERIAL VALLEY DR","city":"HOUSTON","state":"TX","location":{"lat":29.951786,"lng":-95.400813}},{"name":"GROVE LIQUORS","address":"7965 SR 50","city":"GROVELAND","state":"FL","location":{"lat":28.5598475,"lng":-81.8220308}},{"name":"HALLINAN LIQUOR STORE","address":"3504 W GENESEE ST","city":"SYRACUSE","state":"NY","location":{"lat":43.0487512,"lng":-76.2315655}},{"name":"HAPPY'S WINE & SPIRITS","address":"5925 UNIVERSITY AVE","city":"CEDAR FALLS","state":"IA","location":{"lat":42.5123068,"lng":-92.4294419}},{"name":"HARLEY'S CUT-RATE LIQUOR 19","address":"1302 LOOP 281 WEST","city":"LONGVIEW","state":"TX","location":{"lat":32.5315453,"lng":-94.77142099999999}},{"name":"HAWAII MARKET","address":"120 E VALLEY BLVD","city":"SAN GABRIEL","state":"CA","location":{"lat":34.0792342,"lng":-118.0987155}},{"name":"HOMEWOOD DELI & LIQUOR","address":"18222 HALSTED ST","city":"HOMEWOOD","state":"IL","location":{"lat":41.558259,"lng":-87.636634}},{"name":"HOUSE OF LIQUOR","address":"1008 E COLORADO ST","city":"GLENDALE","state":"CA","location":{"lat":34.1423332,"lng":-118.2426895}},{"name":"I LOVE LIQUOR","address":"1632 COLLINS AVE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.790276,"lng":-80.130335}},{"name":"INTERNATIONAL LIQUOR & WI","address":"2578 MAIN ST","city":"BUFFALO","state":"NY","location":{"lat":42.9386,"lng":-78.84037599999999}},{"name":"JIMMY'S LIQUOR","address":"1387 HYLAN BLVD","city":"STATEN ISLAND","state":"NY","location":{"lat":40.5947598,"lng":-74.0868127}},{"name":"JJ BUCKLEY","address":"7305 EDGEWATER DR","city":"OAKLAND","state":"CA","location":{"lat":37.7447502,"lng":-122.2064978}},{"name":"JOE'S DISCOUNT LIQUORS","address":"6203 WEST SANDLAKE ROAD","city":"ORLANDO","state":"FL","location":{"lat":28.4507629,"lng":-81.4663763}},{"name":"JOES LIQUOR & MINI MART","address":"18248 SOLEDAD CYN RD","city":"SANTA CLARITA","state":"CA","location":{"lat":34.4157986,"lng":-118.4512343}},{"name":"JUANITO'S LIQUOR STORE INC.","address":"7810 N LOOP DR","city":"EL PASO","state":"TX","location":{"lat":31.734929,"lng":-106.359404}},{"name":"K & L (WINE)","address":"3005 EL CAMINO REAL","city":"REDWOOD CITY","state":"CA","location":{"lat":37.4684844,"lng":-122.210237}},{"name":"K & L WINE MERCHANT","address":"855 HARRISON ST","city":"SAN FRANCISCO","state":"CA","location":{"lat":37.7796724,"lng":-122.4006149}},{"name":"K & L WINE MERCHANTS","address":"1400 VINE ST","city":"LOS ANGELES","state":"CA","location":{"lat":34.0964711,"lng":-118.3263326}},{"name":"L A LIQUOR STORE","address":"626 W MAIN STREET","city":"ROCHESTER","state":"NY","location":{"lat":43.1518026,"lng":-77.628688}},{"name":"LAKEWOOD MEDALLION DISCOUNT LIQ","address":"5748 LIVE OAK STREET","city":"DALLAS","state":"TX","location":{"lat":32.8112125,"lng":-96.7620433}},{"name":"LATHROP LIQUORS","address":"15326 HARLAN RD","city":"LATHROP","state":"CA","location":{"lat":37.8234005,"lng":-121.289443}},{"name":"LEE'S LIQUOR 15 FLAMBOW","address":"4230 S RAINBOW BLVD","city":"LAS VEGAS","state":"NV","location":{"lat":36.1117912,"lng":-115.2418713}},{"name":"LEGACY LOW COST LIQUOR","address":"655 NORTH KIRKMAN ROAD","city":"ORLANDO","state":"FL","location":{"lat":28.5509024,"lng":-81.4561488}},{"name":"LIQUOR BARN OF WHEELING","address":"287 E DUNDEE RD","city":"WHEELING","state":"IL","location":{"lat":42.1389283,"lng":-87.9089602}},{"name":"LIQUOR CITY USA","address":"965 RICHMOND AVE","city":"STATEN ISLAND","state":"NY","location":{"lat":40.62346,"lng":-74.14813}},{"name":"LIQUOR DEPOT","address":"1308 BEAR CREEK SUITE 110","city":"GLENN HEIGHTS","state":"TX","location":{"lat":32.5596822,"lng":-96.82434699999999}},{"name":"LIQUOR LINEUP","address":"6462 LOSEE RD","city":"N LAS VEGAS","state":"NV","location":{"lat":36.2775679,"lng":-115.1164282}},{"name":"LIQUOR STORE INC","address":"2509 WEBSTER AVE","city":"BRONX","state":"NY","location":{"lat":40.861338,"lng":-73.892011}},{"name":"LIQUORAMA","address":"901 W FOOTHILL BLVD","city":"UPLAND","state":"CA","location":{"lat":34.1084913,"lng":-117.6629949}},{"name":"LIQUORAMA - ON LINE","address":"901 W FOOTHILL BLVD ","city":"UPLAND","state":"CA","location":{"lat":34.1084913,"lng":-117.6629949}},{"name":"MEGA PREMIUM WINE & SPIRI","address":"5335 NW 87 AVENUE","city":"DORAL","state":"FL","location":{"lat":25.8202518,"lng":-80.3371717}},{"name":"MEL & ROSE FINE WINES","address":"8344 MELROSE AVE","city":"LOS ANGELES","state":"CA","location":{"lat":34.0834727,"lng":-118.3718752}},{"name":"MICHAEL'S MARKET & LIQUOR","address":"14890 EL EVADO RD 105","city":"VICTORVILLE","state":"CA","location":{"lat":34.5208292,"lng":-117.3473706}},{"name":"MIKES SHELL","address":"11272 PALMDALE RD","city":"ADELANTO","state":"CA","location":{"lat":34.5070608,"lng":-117.4176346}},{"name":"MISSION LIQUOR - WINE","address":"1801 E WASHINGTON BLVD","city":"PASADENA","state":"CA","location":{"lat":34.1693114,"lng":-118.1132994}},{"name":"MISSION TRAILS MARKET","address":"8181 MISSION GORGE A","city":"SAN DIEGO","state":"CA","location":{"lat":32.8165856,"lng":-117.0599118}},{"name":"MISSION VALLEY MOBIL","address":"5494 MISSION CENTER RD","city":"SAN DIEGO","state":"CA","location":{"lat":32.77420530000001,"lng":-117.1544076}},{"name":"MR A'S GALLERIA WINE & LI","address":"1400 S NELTNOR BLVD","city":"WEST CHICAGO","state":"IL","location":{"lat":41.8621349,"lng":-88.19561980000002}},{"name":"NELSON LIQUOR LAND","address":"1435 N LA BREA AV","city":"INGLEWOOD","state":"CA","location":{"lat":33.9806324,"lng":-118.358773}},{"name":"OAK HILLS MARKET","address":"6000 MARIPOSA RD","city":"OAK HILLS","state":"CA","location":{"lat":34.3599327,"lng":-117.4344626}},{"name":"OAKS LIQUOR","address":"8801 GLENOAKS BL","city":"SUN VALLEY","state":"CA","location":{"lat":34.2289056,"lng":-118.3658493}},{"name":"PALISADES WINE & SPIRITS","address":"544 PALISADES DR","city":"PACIFIC PALISADES","state":"CA","location":{"lat":34.0459076,"lng":-118.551741}},{"name":"PARK AVE LIQUOR SHOP","address":"270 MADISON AVE.","city":"NEW YORK","state":"NY","location":{"lat":40.7512341,"lng":-73.98071139999999}},{"name":"PORTOFINO WINE BANK","address":"500 SOUTH POINT DRIVE 110","city":"MIAMI BEACH","state":"FL","location":{"lat":25.768076,"lng":-80.1346437}},{"name":"PREMIER CHAMPAGNE","address":"22336 MEEKLAND AVE E","city":"HAYWARD","state":"CA","location":{"lat":37.669142,"lng":-122.1007423}},{"name":"PRICE RIGHT WINE & LIQUOR","address":"1520 RTE 55","city":"LAGRANGEVILLE","state":"NY","location":{"lat":41.6699292,"lng":-73.7626329}},{"name":"QUALITY MARKET","address":"2329 MADISON AV","city":"SAN DIEGO","state":"CA","location":{"lat":32.760977,"lng":-117.139486}},{"name":"QUICK LIQUORS","address":"1751 HOVER ST","city":"LONGMONT","state":"CO","location":{"lat":40.189494,"lng":-105.131854}},{"name":"RALPHS MARKET 022","address":"645 9TH ST","city":"LOS ANGELES","state":"CA","location":{"lat":34.0455904,"lng":-118.2607684}},{"name":"RALPHS MARKET 027","address":"74884 COUNTRY CLUB","city":"PALM DESERT","state":"CA","location":{"lat":33.760427,"lng":-116.3579452}},{"name":"RALPHS MARKET 055","address":"521 FOOTHILL BL","city":"LA CANADA","state":"CA","location":{"lat":34.2007863,"lng":-118.1896553}},{"name":"RALPHS MARKET 133","address":"10901 VENTURA BL","city":"STUDIO CITY","state":"CA","location":{"lat":34.1397076,"lng":-118.3678423}},{"name":"RALPHS MARKET 160","address":"49908 JEFFERSON ST","city":"INDIO","state":"CA","location":{"lat":33.6867016,"lng":-116.2671357}},{"name":"RALPHS MARKET 175","address":"7140 AVENIDA ENCINAS","city":"CARLSBAD","state":"CA","location":{"lat":33.1011716,"lng":-117.3105157}},{"name":"RALPHS MARKET 181","address":"1733 E PALM CANYON DR","city":"PALM SPRINGS","state":"CA","location":{"lat":33.7999934,"lng":-116.5262135}},{"name":"RALPHS MARKET 222","address":"14049 VENTURA BL","city":"SHERMAN OAKS","state":"CA","location":{"lat":34.1499568,"lng":-118.4391832}},{"name":"RALPHS MARKET 287","address":"811 AVENIDA TALEGA","city":"SAN CLEMENTE","state":"CA","location":{"lat":33.4622635,"lng":-117.5983912}},{"name":"RALPHS MARKET 289","address":"5601 WILSHIRE BL","city":"LOS ANGELES","state":"CA","location":{"lat":34.0634065,"lng":-118.3513524}},{"name":"RALPHS MARKET 681","address":"42150 WASHINGTON ST","city":"BERMUDA DUNES","state":"CA","location":{"lat":33.7419549,"lng":-116.3019834}},{"name":"RALPHS MARKET 701","address":"12842 VENTURA BL","city":"STUDIO CITY","state":"CA","location":{"lat":34.144155,"lng":-118.4133428}},{"name":"RALPHS MARKET 720","address":"30019 S HAWTHORNE BL","city":"RNCHO PALOS VERDES","state":"CA","location":{"lat":33.7604748,"lng":-118.3946974}},{"name":"RALPHS MARKET 730","address":"3601 E FOOTHILL BL","city":"PASADENA","state":"CA","location":{"lat":34.1513791,"lng":-118.0752917}},{"name":"RALPHS MARKET 738","address":"28231 CROWN VLY PKWY","city":"LAGUNA NIGUEL","state":"CA","location":{"lat":33.55386610000001,"lng":-117.6874119}},{"name":"RALPHS MARKET 739","address":"32555 GOLDEN LANTERN","city":"DANA POINT","state":"CA","location":{"lat":33.4902836,"lng":-117.6995984}},{"name":"RALPHS MARKET 755","address":"26901 ALISO CREEK RD","city":"ALISO VIEJO","state":"CA","location":{"lat":33.5714589,"lng":-117.7257344}},{"name":"RALPHS MARKET 759","address":"10861 WEYBURN AV","city":"LOS ANGELES","state":"CA","location":{"lat":34.0627963,"lng":-118.4438422}},{"name":"RAM LIQUORS","address":"6515 CERMAK RD","city":"BERWYN","state":"IL","location":{"lat":41.8504454,"lng":-87.7868708}},{"name":"RANCHO LIQUOR","address":"28322 OLD TWN FRONT","city":"TEMECULA","state":"CA","location":{"lat":33.4974542,"lng":-117.1527284}},{"name":"RAYAN'S LIQUOR & DELI","address":"4553 N CLARK ST","city":"CHICAGO","state":"IL","location":{"lat":41.964996,"lng":-87.666308}},{"name":"REMEDY LIQUOR","address":"1700 W GLENOAKS BLVD  UNIT B","city":"GLENDALE","state":"CA","location":{"lat":34.1710939,"lng":-118.290178}},{"name":"RIALTO LIQUORS","address":"24 MOUNTAIN MALL PLAZA","city":"MONTICELLO","state":"NY","location":{"lat":41.6512398,"lng":-74.6776196}},{"name":"ROYALTY LIQUOR & MARKET","address":"6200 S SAN PEDRO ST","city":"LOS ANGELES","state":"CA","location":{"lat":33.9831394,"lng":-118.2693628}},{"name":"SANTORI'S LIQUORS","address":"3529 RIDGE RD.","city":"LANSING","state":"IL","location":{"lat":41.5640027,"lng":-87.531111}},{"name":"SARATOGA WINE EXCHANGE TH","address":"43 D ROUND LAKE RD","city":"BALLSTON LAKE","state":"NY","location":{"lat":42.9343365,"lng":-73.81292789999999}},{"name":"SAVE ON LIQUOR","address":"4988 N FRESNO ST","city":"FRESNO","state":"CA","location":{"lat":36.8080434,"lng":-119.78098}},{"name":"SHAMROCK WINE & LIQUOR LL","address":"3565 ROUTE 9W","city":"HIGHLAND","state":"NY","location":{"lat":41.7141817,"lng":-73.96410329999999}},{"name":"SHOTS LIQUOR & BAR","address":"2874 NORTH STATE ROAD 7","city":"LAUDERDALE LAKES","state":"FL","location":{"lat":26.1608757,"lng":-80.2025586}},{"name":"SLAUSON LIQUOR SPOT","address":"4834 W SLAUSON AV","city":"LOS ANGELES","state":"CA","location":{"lat":33.9876946,"lng":-118.3615403}},{"name":"SPEC'S 000 WAREHOUSE WINE MAIN","address":"2410 SMITH ST","city":"HOUSTON","state":"TX","location":{"lat":29.7486202,"lng":-95.37729739999999}},{"name":"SPEC'S 005 WINE MAIN","address":"8102 WESTHEIMER","city":"HOUSTON","state":"TX","location":{"lat":29.7382309,"lng":-95.5106404}},{"name":"SPEC'S 023 WINE MAIN","address":"5130 RICHMOND AVE","city":"HOUSTON","state":"TX","location":{"lat":29.7327542,"lng":-95.4642654}},{"name":"SPEC'S 061 WINE MAIN","address":"4970 US 290 WEST","city":"AUSTIN","state":"TX","location":{"lat":30.2363255,"lng":-97.8207249}},{"name":"SPEC'S 088 WINE MAIN RICHARDS","address":"2545 KIRBY DRIVE","city":"HOUSTON","state":"TX","location":{"lat":29.7430613,"lng":-95.4184248}},{"name":"SPEC'S 091 WINE MAIN","address":"8830 CLAY ROAD","city":"HOUSTON","state":"TX","location":{"lat":29.8359241,"lng":-95.509411}},{"name":"SPEC'S 141 WINE MAIN","address":"3404 N CENTRAL EXPRESSWAY SUITE 100","city":"PLANO","state":"TX","location":{"lat":33.04149220000001,"lng":-96.70188809999999}},{"name":"SPEC'S 150 WINE MAIN","address":"9500 N CENT EXPRESSWAY SUITE 200","city":"DALLAS","state":"TX","location":{"lat":32.8685382,"lng":-96.7735105}},{"name":"SPIRITS 365","address":"10570 GANDY BLVD","city":"SAINT PETERSBURG","state":"FL","location":{"lat":27.8668625,"lng":-82.6261114}},{"name":"STAR 1 MARKET","address":"13462 E MANNING AVE","city":"PARLIER","state":"CA","location":{"lat":36.6052,"lng":-119.548114}},{"name":"SUAREZ LIQUORS","address":"799 West 29TH ST","city":"HIALEAH","state":"FL","location":{"lat":25.8482287,"lng":-80.29795299999999}},{"name":"SUISUN WINE & SPIRITS","address":"141 SUNSET BLVD A","city":"SUISUN CITY","state":"CA","location":{"lat":38.2462833,"lng":-122.0189688}},{"name":"TARZANA WINE & SPIRITS","address":"18839 VENTURA BL","city":"TARZANA","state":"CA","location":{"lat":34.1723749,"lng":-118.5438938}},{"name":"TEMECULA WINE & SPIRITS","address":"33321 TEMECULA PKWY 105","city":"TEMECULA","state":"CA","location":{"lat":33.4860818,"lng":-117.0774434}},{"name":"THE BOTTLE SHOP","address":"1200 COAST VILLAGE RD","city":"SANTA BARBARA","state":"CA","location":{"lat":34.4214086,"lng":-119.6444024}},{"name":"THE WINE CARE GROUP","address":"6475 E PACIFIC CST HWY, SUITE 206","city":"LONG BEACH","state":"CA","location":{"lat":33.7575746,"lng":-118.1083652}},{"name":"THE WINE CARE GROUP INC","address":"6475 E PACIFIC COAST HWY 206","city":"LONG BEACH","state":"CA","location":{"lat":33.7575746,"lng":-118.1083652}},{"name":"TOTAL WINE SPIRITS & MORE","address":"1230 OLD COUNTRY ROAD UNIT 40","city":"WESTBURY","state":"NY","location":{"lat":40.74343510000001,"lng":-73.5999988}},{"name":"TOWN & COUNTRY LIQUORS","address":"2944 W 47TH ST","city":"CHICAGO","state":"IL","location":{"lat":41.808462,"lng":-87.69843700000001}},{"name":"TOWN ARMANETTI BEVERAGE M","address":"10000 S. WESTERN AVE","city":"CHICAGO","state":"IL","location":{"lat":41.7116704,"lng":-87.6822092}},{"name":"TRITON LIQUORS","address":"2897 COLLINS AVE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.8047091,"lng":-80.1249871}},{"name":"UNITED LIQUORS","address":"12435 WESTERN AVE","city":"BLUE ISLAND","state":"IL","location":{"lat":41.667041,"lng":-87.680005}},{"name":"VALLEJO FOOD FAIR MARKET","address":"701 MINI DR","city":"VALLEJO","state":"CA","location":{"lat":38.15272,"lng":-122.2490147}},{"name":"VENDOME WINE & SPIRITS","address":"11555 VENTURA BL","city":"STUDIO CITY","state":"CA","location":{"lat":34.1402696,"lng":-118.3836501}},{"name":"VINTAGE LIQ & WINE BAR II","address":"3301 NE 1ST AVE","city":"MIAMI","state":"FL","location":{"lat":25.8077921,"lng":-80.192374}},{"name":"VINTAGE LIQUORS (OFF)","address":"11753 SOUTH DIXIE HWY","city":"PINECREST POSTAL STO","state":"FL","location":{"lat":25.6651311,"lng":-80.3235127}},{"name":"WAUKEGAN LIQUOR AND QUICK","address":"2728 BELVIDERE RD","city":"WAUKEGAN","state":"IL","location":{"lat":42.3499855,"lng":-87.869923}},{"name":"WEST KENDALL LIQUORS","address":"10590 N KENDALL DRIVE","city":"MIAMI","state":"FL","location":{"lat":25.6865024,"lng":-80.3645043}},{"name":"WILSON LIQUOR","address":"916 E 8TH ST ","city":"NATIONAL CITY","state":"CA","location":{"lat":32.6781542,"lng":-117.0973039}},{"name":"WINE & LIQUOR","address":"2446 ARMY TRAIL RD","city":"HANOVER PARK","state":"IL","location":{"lat":41.942293,"lng":-88.166035}},{"name":"WINE & SPIRITS DISCOUNT W","address":"8 JOYCE RD STORE","city":"NEW ROCHELLE","state":"NY","location":{"lat":40.916994,"lng":-73.7787503}},{"name":"WINE BANK","address":"363 5TH AV","city":"SAN DIEGO","state":"CA","location":{"lat":32.7091318,"lng":-117.1597926}},{"name":"WINE HOUSE","address":"2311 COTNER AV","city":"LOS ANGELES","state":"CA","location":{"lat":34.0374249,"lng":-118.4383804}},{"name":"WINE ON NINE","address":"177 9TH AVE","city":"NEW YORK","state":"NY","location":{"lat":40.7450569,"lng":-74.0027927}},{"name":"WINE.COM","address":"2220 4TH ST","city":"BERKELEY","state":"CA","location":{"lat":37.8645153,"lng":-122.2990444}},{"name":"WINE.COM","address":"2220 4TH ST","city":"BERKELEY","state":"CA","location":{"lat":37.8645153,"lng":-122.2990444}},{"name":"WINE.COM","address":"753 SUMMA AVE","city":"WESTBURY","state":"NY","location":{"lat":40.7589644,"lng":-73.55572339999999}},{"name":"WINE.COM","address":"9333 MILLSVIEW ROAD","city":"HOUSTON","state":"TX","location":{"lat":29.9634491,"lng":-95.5588904}},{"name":"WINEANDLIQUORSUPERSTORE","address":"815 HUTCHINSON RIVER PKWY","city":"BRONX","state":"NY","location":{"lat":40.8234651,"lng":-73.8373412}},{"name":"WOODMAN'S FOOD MARKET","address":"151 HANSEN BLVD","city":"NORTH AURORA","state":"IL","location":{"lat":41.8040542,"lng":-88.3703113}},{"name":"XO GIOVANNIS LIQUOR","address":"953 E SAHARA AVE Suite F","city":"LAS VEGAS","state":"NV","location":{"lat":36.142244,"lng":-115.1423178}}]
var MODLocationsToDrink = [{"name":"538","address":"538 S FLOWER ST","city":"LOS ANGELES","state":"CA","location":{"lat":34.0504016,"lng":-118.2566321}},{"name":"BOOTSY BELLOWS","address":"9229 W SUNSET BLVD","city":"WEST HOLLYWOOD","state":"CA","location":{"lat":34.0904502,"lng":-118.3928048}},{"name":"CLEO LOS ANGELES","address":"1717 VINE STREET","city":"LOS ANGELES","state":"CA","location":{"lat":34.1023986,"lng":-118.3269499}},{"name":"CLEO WEST HOLLYWOOD","address":"8384 W 3RD ST","city":"LOS ANGELES","state":"CA","location":{"lat":34.0727833,"lng":-118.3729511}},{"name":"ENCORE AT WYNN LAS VEGAS","address":"3131 LAS VEGAS BLVD","city":"LAS VEGAS","state":"NV","location":{"lat":36.1271069,"lng":-115.1648303}},{"name":"HYDE SUNSET KITCHEN & COCKTAILS","address":"8117 SUNSET BLVD","city":"WEST HOLLYWOOD","state":"CA","location":{"lat":34.09821460000001,"lng":-118.3660098}},{"name":"IVORY ON SUNSET","address":"8440 SUNSET BLVD","city":"WEST HOLLYWOOD","state":"CA","location":{"lat":34.0946425,"lng":-118.3740744}},{"name":"JEREMY WEST HOLLYWOOD","address":"8490 SUNSET BLVD","city":"WEST HOLLYWOOD","state":"CA","location":{"lat":34.0940701,"lng":-118.375675}},{"name":"KATSUYA RESTAURANT","address":"6300 HOLLYWOOD BLVD","city":"LOS ANGELES","state":"CA","location":{"lat":34.1013407,"lng":-118.3269521}},{"name":"SANTA MONICA PROPER","address":"700 WILSHIRE BLVD","city":"SANTA MONICA","state":"CA","location":{"lat":34.0206953,"lng":-118.4945041}},{"name":"SHUTTERS ON THE BEACH","address":"1 PICO BLVD","city":"SANTA MONICA","state":"CA","location":{"lat":34.006921,"lng":-118.491694}},{"name":"SPAGO","address":"176 N CANON DR","city":"BEVERLY HILLS","state":"CA","location":{"lat":34.0676932,"lng":-118.3975176}},{"name":"TANAS RESTAURANT","address":"9071 W SANTA MONICA","city":"WEST HOLLYWOOD","state":"CA","location":{"lat":34.0817887,"lng":-118.3890799}},{"name":"WARWICK","address":"6507 SUNSET BLVD","city":"LOS ANGELES","state":"CA","location":{"lat":34.0982302,"lng":-118.3314468}},{"name":"1 HOTEL SOUTH BEACH","address":"2341 COLLINS AVENUE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.7989787,"lng":-80.1268868}},{"name":"ACQUALINA RESORT & SPA ON","address":"17875 COLLINS AVENUE","city":"SUNNY ISLES BEACH","state":"FL","location":{"lat":25.9408209,"lng":-80.1209181}},{"name":"ALTITUDE at SLS LUX BRICKE","address":"801 SOUTH MIAMI AVENUE","city":"MIAMI","state":"FL","location":{"lat":25.7659322,"lng":-80.19299869999999}},{"name":"AMARA AT PARAISO","address":"3101 NE 7TH AVE","city":"MIAMI","state":"FL","location":{"lat":25.8064966,"lng":-80.1856557}},{"name":"AMBASSADOR CHINESE RESTAURANT A","address":"4326 RICHMOND AVE","city":"HOUSTON","state":"TX","location":{"lat":29.732961,"lng":-95.449376}},{"name":"AVENUE","address":"2912 MCKINNEY AVENUE","city":"DALLAS","state":"TX","location":{"lat":32.80011,"lng":-96.80046000000002}},{"name":"BAOLI MIAMI","address":"1906 COLLINS AVENUE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.7953747,"lng":-80.1294356}},{"name":"BROWN HOTEL PRIME 112","address":"112 OCEAN DRIVE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.76992,"lng":-80.13326699999999}},{"name":"BRUJERIA NIGHT CLUB & SHOT BAR","address":"322 S 17TH STREET","city":"MCALLEN","state":"TX","location":{"lat":26.2011354,"lng":-98.2386664}},{"name":"BUCK'S CABARET","address":"2345 MEACHAM BOULEVARD","city":"FORT WORTH","state":"TX","location":{"lat":32.825008,"lng":-97.32176}},{"name":"BUCKS CABARET","address":"2150 CALIFORNIA CROSSING ROAD","city":"DALLAS","state":"TX","location":{"lat":32.8652495,"lng":-96.9081265}},{"name":"BYBLOS MIAMI","address":"1545 COLLINS AVENUE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.7882791,"lng":-80.12969180000002}},{"name":"CAFE J","address":"2605 19TH ST.","city":"LUBBOCK","state":"TX","location":{"lat":33.5772096,"lng":-101.8732669}},{"name":"CAPO","address":"1810 OCEAN AVE","city":"SANTA MONICA","state":"CA","location":{"lat":34.0079856,"lng":-118.491221}},{"name":"CARBONE","address":"181 THOMPSON ST","city":"NEW YORK","state":"NY","location":{"lat":40.7279895,"lng":-74.00021819999999}},{"name":"CAVALI NY","address":"36 STEINWAY ST","city":"LONG ISLAND CITY","state":"NY","location":{"lat":40.7646253,"lng":-73.9145602}},{"name":"CITIZEN","address":"2923 FAIRMOUNT STREET","city":"DALLAS","state":"TX","location":{"lat":32.798351,"lng":-96.806462}},{"name":"CLE","address":"2301 MAIN ST SUITE 400","city":"HOUSTON","state":"TX","location":{"lat":29.7468315,"lng":-95.37248609999999}},{"name":"CLEVELANDER HOTEL","address":"1020 OCEAN DRIVE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.780825,"lng":-80.13093889999999}},{"name":"CONCRETE COWBOY FRISCO AT THE STAR","address":"3685 THE STAR BOULEVARD SUITE 210","city":"FRISCO","state":"TX","location":{"lat":33.108249,"lng":-96.82869219999999}},{"name":"CRAIG'S RESTAURANT","address":"8826 MELROSE AV","city":"WEST HOLLYWOOD","state":"CA","location":{"lat":34.0806131,"lng":-118.3864471}},{"name":"CRAVE RESTAURANT & LOUNGE","address":"129 WASHINGTON ST","city":"POUGHKEEPSIE","state":"NY","location":{"lat":41.7110309,"lng":-73.9294493}},{"name":"DELANO HOTEL UMI BIANCA D","address":"1685 COLLINS AVENUE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.792101,"lng":-80.129239}},{"name":"DOHENY ROOM","address":"9077 SANTA MONICA BLVD","city":"WEST HOLLYWOOD","state":"CA","location":{"lat":34.0817013,"lng":-118.3892351}},{"name":"DOVE CANYON COUNTRY CLUB","address":"22682 GOLF CLUB DR","city":"DOVE CANYON","state":"CA","location":{"lat":33.6327914,"lng":-117.5687616}},{"name":"EL TUCAN & MARION","address":"1111 SW 1ST AVE","city":"MIAMI","state":"FL","location":{"lat":25.762752,"lng":-80.1946689}},{"name":"EVERGLADES CLUB GOLF BAR","address":"356 WORTH AVE","city":"PALM BEACH","state":"FL","location":{"lat":26.700729,"lng":-80.040958}},{"name":"FAENA LOS FUEGOS","address":"3201 COLLINS AVE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.8074337,"lng":-80.1235138}},{"name":"FAENA SAXONY THEATER","address":"3201 COLLINS AVE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.8074337,"lng":-80.1235138}},{"name":"FINE WINE & TASTINGS ON M","address":"8111 LAKEWOOD MAIN STREET","city":"LAKEWOOD RANCH","state":"FL","location":{"lat":27.394831,"lng":-82.4347857}},{"name":"FOGUEIRA GAUCHA","address":"2000 S Interstate 35 D1","city":"ROUND ROCK","state":"TX","location":{"lat":30.4892037,"lng":-97.67992310000001}},{"name":"FRANKLIN MANOR","address":"912 N FRANKLIN ST","city":"TAMPA","state":"FL","location":{"lat":27.951769,"lng":-82.460028}},{"name":"FRENCH LAUNDRY REST","address":"6640 WASHINGTON ST","city":"YOUNTVILLE","state":"CA","location":{"lat":38.4044403,"lng":-122.3649712}},{"name":"G MIGS","address":"128 5TH STREET","city":"WEST DES MOINES","state":"IA","location":{"lat":41.570626,"lng":-93.70926299999999}},{"name":"GODFREY HOTELS & CABANAS","address":"7700 COURTNEY CAMPBELL CAUSEWAY","city":"TAMPA","state":"FL","location":{"lat":27.9672808,"lng":-82.5704598}},{"name":"HYDE LOUNGE at T-MOBILE AREN","address":"3780 LAS VEGAS BLVD","city":"LAS VEGAS","state":"NV","location":{"lat":36.1031181,"lng":-115.1781703}},{"name":"INTERCONTINENTAL HOTEL MI","address":"100 CHOPIN PLAZA","city":"MIAMI","state":"FL","location":{"lat":25.7720361,"lng":-80.1858501}},{"name":"J W MARRIOTT","address":"74855 COUNTRY CLUB","city":"PALM DESERT","state":"CA","location":{"lat":33.755446,"lng":-116.361843}},{"name":"JW MARRIOTT HOTEL AT LA L","address":"900 W OLYMPIC BLVD","city":"LOS ANGELES","state":"CA","location":{"lat":34.0452408,"lng":-118.2664713}},{"name":"KAORU MC CORP","address":"310 E 46TH ST","city":"NEW YORK","state":"NY","location":{"lat":40.7518591,"lng":-73.9698958}},{"name":"KATSUYA","address":"702 AMERICANA WAY","city":"GLENDALE","state":"CA","location":{"lat":34.144115,"lng":-118.2564027}},{"name":"KATSUYA","address":"11777 SAN VINCENTE BLVD","city":"LOS ANGELES","state":"CA","location":{"lat":34.0532727,"lng":-118.4685844}},{"name":"KATSUYA AT SLS LUX BRICKE","address":"801 SOUTH MIAMI AVENUE","city":"MIAMI","state":"FL","location":{"lat":25.7659322,"lng":-80.19299869999999}},{"name":"KATSUYA DOWNTOWN LA","address":"800 W OLYMPIC BLVD","city":"LOS ANGELES","state":"CA","location":{"lat":34.0446889,"lng":-118.2654753}},{"name":"KOMODO","address":"801 BRICKELL AVENUE","city":"MIAMI","state":"FL","location":{"lat":25.765513,"lng":-80.1899244}},{"name":"KUMI @ MANDALAY BAY","address":"3950 S LAS VEGAS BLVD","city":"LAS VEGAS","state":"NV","location":{"lat":36.0918777,"lng":-115.175245}},{"name":"LA COCINA BAR & GRILL GVR","address":"19915 GOLDEN VALLEY RD","city":"SANTA CLARITA","state":"CA","location":{"lat":34.3955731,"lng":-118.4839531}},{"name":"LAKE FOREST WINES","address":"2222 FRANCISCO DR","city":"EL DORADO HILLS","state":"CA","location":{"lat":38.7102093,"lng":-121.0861929}},{"name":"LAVO","address":"625 MADISON AVE","city":"NEW YORK","state":"NY","location":{"lat":40.763143,"lng":-73.97133819999999}},{"name":"LB STEAK","address":"334 SANTANA ROW STE 1000","city":"SAN JOSE","state":"CA","location":{"lat":37.3225293,"lng":-121.9476646}},{"name":"LIVE ULTRA LOUNGE","address":"19314 HWY 281N SUITE 101","city":"SAN ANTONIO","state":"TX","location":{"lat":29.4241219,"lng":-98.49362819999999}},{"name":"LOS CAPOS NIGHTCLUB & RES","address":"7588 MONTEREY ST","city":"GILROY","state":"CA","location":{"lat":37.00942879999999,"lng":-121.5694218}},{"name":"MA'S ITALIAN KITCHEN","address":"267 N PASS AVE","city":"BURBANK","state":"CA","location":{"lat":34.154502,"lng":-118.345996}},{"name":"MADEO","address":"362 N CAMDEN DR","city":"BEVERLY HILLS","state":"CA","location":{"lat":34.0683982,"lng":-118.4035766}},{"name":"MAKE BELIEVE","address":"187 ORCHARD STREET","city":"NEW YORK","state":"NY","location":{"lat":40.7221444,"lng":-73.9883924}},{"name":"MANDARIN ORIENTAL MIAMI","address":"500 BRICKELL KEY DRIVE","city":"MIAMI","state":"FL","location":{"lat":25.7650252,"lng":-80.18516939999999}},{"name":"MARRIOTT NEWPORT BCH","address":"900 NEWPORT CENTER DRIVE","city":"NEWPORT BEACH","state":"CA","location":{"lat":33.6163322,"lng":-117.879497}},{"name":"MASON","address":"108 W CHANNEL RD","city":"LOS ANGELES","state":"CA","location":{"lat":34.0283383,"lng":-118.5189364}},{"name":"MASON BLIND DRAGON","address":"611 N WELLS ST FL","city":"CHICAGO","state":"IL","location":{"lat":41.89286999999999,"lng":-87.633797}},{"name":"MASTRO'S STEAKHOUSE","address":"246 N CANON DR","city":"BEVERLY HILLS","state":"CA","location":{"lat":34.0688605,"lng":-118.3987677}},{"name":"MATTHEW'S LIVE OAKS","address":"37822 OAKS CT","city":"BOULEVARD","state":"CA","location":{"lat":32.6882771,"lng":-116.3351965}},{"name":"MEAT MARKET","address":"915 LINCOLN ROAD","city":"MIAMI BEACH","state":"FL","location":{"lat":25.7907045,"lng":-80.1379889}},{"name":"MEAT MARKET PALM BEACH","address":"191 BRADLEY PLACE","city":"PALM BEACH","state":"FL","location":{"lat":26.7219817,"lng":-80.040849}},{"name":"MIAMI BEACH EDITION HOTEL","address":"2901 COLLINS AVENUE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.8050585,"lng":-80.12440509999999}},{"name":"MICHAEL JOHNS","address":"1040 CARLTON ARMS BLVD","city":"BRADENTON","state":"FL","location":{"lat":27.4993309,"lng":-82.51660179999999}},{"name":"MICHAEL MINA","address":"252 CALIFORNIA ST","city":"SAN FRANCISCO","state":"CA","location":{"lat":37.79346,"lng":-122.399638}},{"name":"MIMOSA HOUSE","address":"3155 ZINFANDEL DR  STE 100","city":"RANCHO CORDOVA","state":"CA","location":{"lat":38.585507,"lng":-121.28521}},{"name":"MIO NONNO TRATTORIA","address":"2588 N HOUSTON STREET SUITE 100","city":"DALLAS","state":"TX","location":{"lat":32.7908176,"lng":-96.80906039999999}},{"name":"MONDRIAN SKY BAR","address":"8440 SUNSET BL","city":"WEST HOLLYWOOD","state":"CA","location":{"lat":34.0946425,"lng":-118.3740744}},{"name":"MONTAGE HOTELS & RESORTS","address":"30801 COAST HWY","city":"LAGUNA BEACH","state":"CA","location":{"lat":33.5148414,"lng":-117.7572136}},{"name":"MYNT LOUNGE","address":"1921 COLLINS AVENUE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.7952686,"lng":-80.1290599}},{"name":"NICE GUY","address":"401 N LA CIENEGA BLVD","city":"LOS ANGELES","state":"CA","location":{"lat":34.07872,"lng":-118.37683}},{"name":"NIGHTINGALE","address":"643 N LA CIENEGA BLVD","city":"LOS ANGELES","state":"CA","location":{"lat":34.0832342,"lng":-118.376685}},{"name":"NOVIKOV RESTAURANT AND BA","address":"300 SOUTH BISVAYNE BLVD","city":"MIAMI","state":"FL","location":{"lat":25.790869,"lng":-80.18617809999999}},{"name":"PETITE TAQUERIA","address":"755 N LA CIENEGA BLVD","city":"LOS ANGELES","state":"CA","location":{"lat":34.0851589,"lng":-118.3766731}},{"name":"POOL & GRILL","address":"99 E 52ND ST","city":"NEW YORK","state":"NY","location":{"lat":40.7583177,"lng":-73.9718681}},{"name":"QUALITY MEATS","address":"1501 COLLINS AVENUE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.7880834,"lng":-80.12996319999999}},{"name":"RED SQUARE","address":"3950 S LAS VEGAS BLVD","city":"LAS VEGAS","state":"NV","location":{"lat":36.0918777,"lng":-115.175245}},{"name":"ROKU","address":"9201 W SUNSET BLVD","city":"WEST HOLLYWOOD","state":"CA","location":{"lat":34.0910841,"lng":-118.3926678}},{"name":"ROSS CODE LOUNGE","address":"117 101ST AVE","city":"RICHMOND HILL","state":"NY","location":{"lat":40.6893827,"lng":-73.8274453}},{"name":"RUBAIYAT","address":"117 WEST WATER STREET","city":"DECORAH","state":"IA","location":{"lat":43.304033,"lng":-91.786754}},{"name":"SADDLE BROOK RESORTS","address":"5700 SADDLEBROOK WAY","city":"WESLEY CHAPEL","state":"FL","location":{"lat":28.2375529,"lng":-82.3340513}},{"name":"SAGE","address":"1216 FIRST STREET","city":"SARASOTA","state":"FL","location":{"lat":27.3370597,"lng":-82.5461547}},{"name":"SARASOTA KENNEL CLUB","address":"5400 BRADENTON ROAD","city":"SARASOTA","state":"FL","location":{"lat":27.380316,"lng":-82.544989}},{"name":"SCARPETTA RESTAURANT","address":"15 E 28TH ST","city":"NEW YORK","state":"NY","location":{"lat":40.7442928,"lng":-73.9861391}},{"name":"SCORES NEW YORK","address":"533 W 27TH ST","city":"NEW YORK","state":"NY","location":{"lat":40.751069,"lng":-74.0037993}},{"name":"SHERATON AGOURA HILLS","address":"30100 AGOURA RD","city":"AGOURA HILLS","state":"CA","location":{"lat":34.1443363,"lng":-118.7794874}},{"name":"SIR FRANCIS DRAKE HTL","address":"450 POWELL ST","city":"SAN FRANCISCO","state":"CA","location":{"lat":37.7890363,"lng":-122.4083445}},{"name":"SLS BRICKELL","address":"1300 SOUTH MIAMI AVENUE","city":"MIAMI","state":"FL","location":{"lat":25.7612107,"lng":-80.1935276}},{"name":"SLS SOUTH BEACH","address":"1701 COLLINS AVENUE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.7925952,"lng":-80.1291181}},{"name":"SPEARMINT RHINO LOUNGE","address":"3340 S HIGHLAND","city":"LAS VEGAS","state":"NV","location":{"lat":36.1286959,"lng":-115.1782831}},{"name":"SPRING PLACE","address":"50 VARICK","city":"NEW YORK","state":"NY","location":{"lat":40.7212535,"lng":-74.0062336}},{"name":"STK SOUTH BEACH","address":"2305 COLLINS AVE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.7985232,"lng":-80.12770789999999}},{"name":"STORY","address":"136 COLLINS AVENUE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.770503,"lng":-80.13421}},{"name":"SUMMIT","address":"120 W 5TH STREET","city":"AUSTIN","state":"TX","location":{"lat":30.2675544,"lng":-97.74393500000001}},{"name":"SUNSET BAR","address":"34700 PACIFIC COAST HWY","city":"DANA POINT","state":"CA","location":{"lat":33.458213,"lng":-117.6716268}},{"name":"SWAN MIAMI","address":"90 NE 39TH STREET","city":"MIAMI","state":"FL","location":{"lat":25.8125145,"lng":-80.1938251}},{"name":"SWAY NIGHTCLUB BOOZE GARD","address":"111 SW 2ND AVENUE","city":"FORT LAUDERDALE","state":"FL","location":{"lat":26.120964,"lng":-80.1459112}},{"name":"TAO DOWNTOWN","address":"369 WEST 16 ST","city":"NEW YORK","state":"NY","location":{"lat":40.7422842,"lng":-74.00410769999999}},{"name":"TEXAS REPUBLIC","address":"941 FOCH STREET","city":"FORT WORTH","state":"TX","location":{"lat":32.7493337,"lng":-97.3563157}},{"name":"THE ADDRESS","address":"3333 RALEIGH STREET","city":"HOUSTON","state":"TX","location":{"lat":29.702071,"lng":-95.37337099999999}},{"name":"THE PACIFIC RIM","address":"1859 HILLVIEW STREET","city":"SARASOTA","state":"FL","location":{"lat":27.3167734,"lng":-82.5325021}},{"name":"THE SHORE CLUB","address":"1901 COLLINS AVENUE","city":"MIAMI BEACH","state":"FL","location":{"lat":25.7948,"lng":-80.12902199999999}},{"name":"THE WINERY","address":"2647 PARK AVE","city":"TUSTIN","state":"CA","location":{"lat":33.6970133,"lng":-117.827342}},{"name":"TRAVIS MIDTOWN LLC A","address":"2200 MAIN STREET","city":"HOUSTON","state":"TX","location":{"lat":29.7479803,"lng":-95.3723375}},{"name":"TWISTED GLASSES","address":"2222 FRANCISCO DR","city":"EL DORADO HILLS","state":"CA","location":{"lat":38.7102093,"lng":-121.0861929}},{"name":"VILLA AZUR LA CAVE D'AZ","address":"309 23RD STREET","city":"MIAMI BEACH","state":"FL","location":{"lat":25.7989132,"lng":-80.1291972}}]
var GoogleMapTheme = [{"elementType":"geometry","stylers":[{"color":"#212121"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#212121"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#757575"},{"visibility":"off"}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"administrative.neighborhood","stylers":[{"visibility":"off"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#181818"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"poi.park","elementType":"labels.text.stroke","stylers":[{"color":"#1b1b1b"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#2c2c2c"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#8a8a8a"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#373737"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#3c3c3c"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#4e4e4e"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#3d3d3d"}]}]
// Stefan's Additions End


$(document).ready(function() {
  
  var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
  if(isMobile)
    $('.wow').removeClass('wow animated');

  verification_popup.init();

  theme.init();

  var sections = new theme.Sections();

  //sections.register('action-bar-section', theme.ActionBarSection);
  //sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('sidebar-menu-section', theme.SidebarMenuSection);
  sections.register('header-section', theme.HeaderSection);
  //sections.register('collection-template-section', theme.CollectionTemplate);
  //sections.register('product', theme.Product);
  //sections.register('rich-text-section', theme.RichTextSection);
  //sections.register('newsletter-signup-section', theme.NewsletterSection);
  //sections.register('featured-video-section', theme.FeaturedVideoSection);
  //sections.register('map-section', theme.Maps);
  sections.register('password-content-section', theme.PasswordContentSection);

  var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};

  var hamburgers = document.querySelectorAll(".hamburger");
  if (hamburgers.length > 0) {
    forEach(hamburgers, function(hamburger) {
      hamburger.addEventListener("click", function() {
        this.classList.toggle("is-active");
        if($('#NewsletterModal').hasClass('modal--is-active')){
          theme.NewsletterModal.close();
          $('button.hamburger').addClass('is-active');
        }
      }, false);
    });
  }
  
  $('#tab-wrapper li:last').addClass('active');
  $('#tab-body > div').hide();
  $('#tab-body > div:last').show();
  $('#tab-wrapper a').on('click', function() {
    $('#tab-wrapper li').removeClass('active');
    $(this).parent().addClass('active');
    var activeTab = $(this).attr('href');
    $('#tab-body > div:visible').hide();
    $(activeTab).fadeIn();
    return false;
  });
  
  $('.site-footer__linklist a, #rev_slider_33_1 a#slide-63-layer-3, #rev_slider_33_1 a#slide-63-layer-5').on('click', function(evt) {
    if($('button.hamburger').hasClass('is-active')){
      $('button.hamburger').trigger('click');
    }
    $('button.hamburger').removeClass('is-active');
    var activesection = $(this).attr('href').substring($(this).attr('href').indexOf('#')+1);
    if(activesection != '' && activesection != 'NewsletterModal'){
      //evt.preventDefault();
      if($('#NewsletterModal').hasClass('modal--is-active'))
        theme.NewsletterModal.close();
      $('.main-content .index-section').hide();
      if( $( '.main-content .index-section' ).hasClass( 'wow' ) ) {
        $( this ).removeAttr( 'style' );
      }
      $('.main-content .index-section').removeClass('wow slideInUp section-active');
      if(activesection == 'purchase-mod-selection'){
        $('.main-content .index-section.location-section').show();
        $('.main-content .index-section.location-section').addClass('wow slideInUp section-active');
        $('.main-content .index-section.location-section #tab-wrapper .location-enjoy').trigger('click');
      }
      else if(activesection == 'location-section'){
        $('.main-content .index-section.location-section').show();
        $('.main-content .index-section.location-section').addClass('wow slideInUp section-active');
        $('.main-content .index-section.location-section #tab-wrapper .location-enjoy').trigger('click');
      }
      else{
        $('.main-content .index-section.' + activesection).show();
        $('.main-content .index-section.' + activesection).addClass('wow slideInUp section-active');
      }
    }
    else if(activesection == 'NewsletterModal'){
      theme.NewsletterModal.open();
    }
  });
  
  var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS');
  if (isSafari){
    $('#contact_form input[type="text"]').wrap('<form />');
  }
  
  $('#PageContainer').click(function() {
    $('button.hamburger').removeClass('is-active');
  });

  /* Submit the form */
  $("#contact_form").submit(function(evt) {
    evt.preventDefault();
    var error_text = $("#contact_form").find('.form-error').text();
    var action  = '/contact?';
    action += encodeURIComponent('form_type') +'='+ encodeURIComponent('contact');/*customer*/
    if($('#ContactFormNewsletter').val() != '')
      action += '&'+ encodeURIComponent('contact[tags]') +'='+ encodeURIComponent('prospect,newsletter');
    action += '&'+ encodeURIComponent('utf8') +'='+ encodeURIComponent('✓');
    action += '&'+ encodeURIComponent('contact[first_name]') +'='+ encodeURIComponent($('#ContactFormFirstName').val());
    action += '&'+ encodeURIComponent('contact[last_name]') +'='+ encodeURIComponent($('#ContactFormLastName').val());
    action += '&'+ encodeURIComponent('contact[email]') +'='+ encodeURIComponent($('#ContactFormEmail').val());
    action += '&'+ encodeURIComponent('contact[body]') +'='+ encodeURIComponent($('#ContactFormMessage').val());
    action += '&'+ encodeURIComponent('contact[note]') +'='+ encodeURIComponent($('#ContactFormMessage').val());
    $.ajax({
      type: "POST",
      async: true,
      url: action,
      error: function(jqXHR, textStatus, errorThrown) {
        error_text = 'Too many submission requests. Please try again in a few minutes.' + jqXHR.responseText;
        $("#contact_form").find('.form-error').text(error_text);
      },
      success: function(response) {
        $("#contact_form").find('.form-success').css( "display", "block" );
        $("#contact_form").find('h3').css( "display", "none" );
        $("#contact_form").find('.contact-wrapper').css( "display", "none" );
      }
    });
    
  });
  
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#tac').is(':checked')) {
      $(this).submit();
    }
    else {
      /*alert("You must agree to our Shipping Terms and Conditions, you are 21 years of age or older and you understand all sales are FINAL.");*/
      return false;
    }
  });
  
  /*var insta_resolution = 'standard_resolution';
  if(isMobile)
    insta_resolution = 'thumbnail';
  
  var userFeed = new Instafeed({
    get: 'user',
    limit: 24,
    userId: 'self',
    target: 'instagram-feed',
    accessToken: '5517245102.1677ed0.f239995b310344c48ac817eb2aa15b94',
    resolution: insta_resolution,
    template: '<a href="{{link}}" target="_blank" ><div class="instafeed-container"><img class="img_responsive" src="{{image}}" /></div></a>'
  });
  userFeed.run();*/
  
  // Stefan's Additions Begin
  function distance(lat1, lon1, lat2, lon2, unit) {
    if ((lat1 == lat2) && (lon1 == lon2)) {
      return 0;
    }
    else {
      var radlat1 = Math.PI * lat1/180;
      var radlat2 = Math.PI * lat2/180;
      var theta = lon1-lon2;
      var radtheta = Math.PI * theta/180;
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = dist * 180/Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit=="K") { dist = dist * 1.609344 }
      if (unit=="N") { dist = dist * 0.8684 }
      return dist;
    }
  }

  function createHTMLForItem(item, tier){
    var template = "<div class=\"tier $tag\">\
    <h4 class=\"storemapper-title\">$title</h4>\
    <p class=\"storemapper-address\">$address</p>\
    <a class=\"storemapper-storelink\" target=\"_blank\" href=\"$storelink\"><img src=\"https:////cdn.shopify.com/s/files/1/0047/0659/8983/t/2/assets/Locator_18x.png?7426\"/> Directions</a>\
    </div>"
    template = template.replace('$tag', tier)
    template = template.replace('$title', item.name)
    template = template.replace('$address', item.address + ' ' + item.city + ' ' + item.state)
    template = template.replace('$storelink','https://www.google.com/maps/dir/?api=1&destination=' + item.address + ' ' + item.city + ' ' + item.state)
    return template

  }
  
  function createTooltipHTMLForItem(item){
    var template = "<div><p class=\"popupinfo\">$itemname</p>\
    <a class=\"popupinfoaddressa\" target=\"_blank\" href=\"$storelink\"><p class=\"popupinfoaddress\">$address</p></a></div>"
    template = template.replace('$itemname', item.name)
    template = template.replace('$address', item.address + '</br>' + item.city + ' ' + item.state)
    template = template.replace('$storelink','https://www.google.com/maps/dir/?api=1&destination=' + item.address + ' ' + item.city + ' ' + item.state)
    return template
  }
  
  
  window.initMap = function(){
    window.zipCode = {
      "lat": 34.0926756,
      "lng": -118.3449134
    }
    window.selectedTab = '.buy';
    var map = new google.maps.Map(document.getElementById('map'), {zoom: 11, center: window.zipCode, styles:GoogleMapTheme, disableDefaultUI: true});
    var infoWindow = new google.maps.InfoWindow({
      content: ""
    })
    var toBuyMarkers = MODLocationsToBuy.map((object) => {
    var marker = new google.maps.Marker({position: object.location, map: map, icon: 'https://modchampagne.com/cdn/shop/t/10/assets/MapMarker.svg?v=182885208661843527671583740799'  });
      var infoObject = Object.assign({}, object);
      marker.addListener('click', function() {
          infoWindow.setContent(createTooltipHTMLForItem(infoObject))
          infoWindow.open(map, marker)
      })
      return marker
   })

   var toDrinkMarkers = MODLocationsToDrink.map((object) => {

     var marker = new google.maps.Marker({position: object.location, map: map, icon: 'https://modchampagne.com/cdn/shop/t/10/assets/MapMarker.svg?v=182885208661843527671583740799' });
        var infoObject = Object.assign({}, object);
        marker.addListener('click', function() {
        infoWindow.setContent(createTooltipHTMLForItem(infoObject))
        infoWindow.open(map, marker)
        })
    return marker
   })

    window.updateList = function(){
      $("#storemapper-list").empty()
      if (window.selectedTab == '.buy') { 
        for (var i=0; i< MODLocationsToBuy.length; i++){
          if (MODLocationsToBuy[i].distance < 100) {
            var html = createHTMLForItem(MODLocationsToBuy[i], 'buy')
            var el = $.parseHTML (html)
            $("#storemapper-list").append(el)
          }
        }
      }

      if (window.selectedTab == '.drink') {
        for (var i=0; i< MODLocationsToDrink.length; i++){
          if (MODLocationsToDrink[i].distance < 100) {
            var html = createHTMLForItem(MODLocationsToDrink[i], 'drink')
            var el = $.parseHTML (html)
            $("#storemapper-list").append(el)
          }
        }
      }

    }

    window.updateMarkers = function(selectedTab){
      window.selectedTab = selectedTab

      for(var i=0; i< toBuyMarkers.length; i++){
        toBuyMarkers[i].setMap(null)
      }
      for(var i=0; i< toDrinkMarkers.length; i++){
        toDrinkMarkers[i].setMap(null)
      }

      if (window.selectedTab == '.buy') {
        for(var i=0; i< toBuyMarkers.length; i++){
          var markerPosition = toBuyMarkers[i].getPosition()
          toBuyMarkers[i].setMap(map)
        }
      }

      if (window.selectedTab == '.drink') {
        for(var i=0; i< toDrinkMarkers.length; i++){
          var markerPosition = toDrinkMarkers[i].getPosition()
          toDrinkMarkers[i].setMap(map)
        }
      }
      map.setCenter(window.zipCode)
      map.setZoom(11)
      window.updateList()
    }

    window.updateZipCode = function(initval){
      var el = $('[name="search"]')
      var zipCode = el.val()
      if(!zipCode)
        zipCode = initval
      var reqURL = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + zipCode + '&key=AIzaSyAVfjP9xZFJH-V7BP6JN19XrnlcefFSKks'
      $.get(reqURL, function(data){
        window.zipCode = data.results[0].geometry.location
        for (var i=0; i<MODLocationsToBuy.length; i++) {
          MODLocationsToBuy[i]['distance'] = distance(MODLocationsToBuy[i].location.lat, MODLocationsToBuy[i].location.lng, window.zipCode.lat, window.zipCode.lng, 'M')
        }
        for (var i=0; i<MODLocationsToDrink.length; i++) {
          MODLocationsToDrink[i]['distance'] = distance(MODLocationsToDrink[i].location.lat, MODLocationsToDrink[i].location.lng, window.zipCode.lat, window.zipCode.lng, 'M')
        }
        window.updateMarkers(window.selectedTab)
      })
      return false
    }

    window.selectedTab = '.drink'
    window.updateZipCode(90046)
  }
  // Stefan's Additions End
});

$(window).load(function() {
  var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
  if(!isMobile)
  	$('.main-content .index-section').addClass('animated');
  /*$('.main-content .index-section').attr( "data-wow-duration", "2s" );
  $('.main-content .index-section').attr( "data-wow-delay", "2s" );*/
  //Stefan's Additions Begin
  $('.button-group').on( 'click', 'button', function() {
    $('.button-group button').removeClass('is-checked');
    $(this).addClass('is-checked');
    window.selectedTab = $(this).data('filter');
    window.updateList();
    window.updateMarkers(window.selectedTab)
  });
  //Stefan's Additions End
});

new WOW().init();

